import ChangeThumbnailSlider from "./ChangeThumbnailSlider";

export default ChangeThumbnailSlider;
